import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://api.aniervincent.fr/api',
});

api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    const agence = localStorage.getItem('agence_active');
    if (agence) config.headers['X-Agence-Id'] = agence;
    return config;
});

export const login = (email, password) =>
    api.post('/auth/login', { email, password });

export const getPatients = () =>
    api.get('/patients?pagination=false');

export const getDeliveries = (dateDebut, dateFin) =>
    api.get(`/deliveries?date[after]=${dateDebut}&date[before]=${dateFin}`);

export const updateDeliveryPosition = (id, data) =>
    api.patch(`/deliveries/${id}`, data, {
        headers: { 'Content-Type': 'application/merge-patch+json' }
    });

export default api;